/**
 * View component for /admin/authoring/sponsors/:sponsorId/update
 *
 * Updates a single sponsor from a copy of the selcted sponsor
 * as defined in the sponsor reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sponsorActions from '../sponsorActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx'; 
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';
// import module components
import SponsorForm from '../components/SponsorForm.js.jsx';

// import sponsor css modules
import sponsorStyles from '../sponsorModuleStyles.css';

class AdminUpdateSponsor extends Base {
  constructor(props) {
    super(props);
    const { selectedSponsor, sponsorMap } = this.props;
    this.state = {
      sponsor: sponsorMap[selectedSponsor.id] ? { ...sponsorMap[selectedSponsor.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
      , confirmClearTokenModalOpen: false
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_generateToken'
      , '_clearToken'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sponsorActions.fetchSingleIfNeeded(match.params.sponsorId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedSponsor, sponsorMap } = nextProps;
    this.setState({
      sponsor: sponsorMap[selectedSponsor.id] ? { ...sponsorMap[selectedSponsor.id] } : {}
      //we don't want to actually change the store's sponsor, just use a copy
    })
  }

  _handleFormChange(e) {
    let newSponsorState = _.update( this.state.sponsor, e.target.name, function() {
      return e.target.value;
    });
    this.setState({sponsor :newSponsorState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(sponsorActions.sendUpdateSponsor(this.state.sponsor)).then((action) => {
      if(action.success) {
        history.push(`/admin/sponsors/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  _generateToken() {
    let newSponsor = _.cloneDeep(this.state.sponsor); 
    newSponsor.authToken = Math.floor(Math.random()*16777215).toString(16) + Math.floor(Math.random()*16777215).toString(16);
    this.setState({sponsor: newSponsor}); 
  }

  _clearToken() {
    let newSponsor = _.cloneDeep(this.state.sponsor); 
    newSponsor.authToken = null; 
    this.setState({sponsor: newSponsor, confirmClearTokenModalOpen: false});
  }

  render() {
    const { location, selectedSponsor, sponsorMap } = this.props;
    const { sponsor } = this.state;
    const isEmpty = (!sponsor || sponsor._id === null || sponsor._id === undefined);

    return  (
      <div className="flex">
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
          </div>
          { isEmpty ?
              (selectedSponsor.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
            :
              <SponsorForm
                cancelLink={`/admin/sponsors/${sponsor._id}`}
                clearToken={this._clearToken}
                formTitle="Update Sponsor"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                generateToken={this._generateToken}
                sponsor={sponsor}
                showClearTokenModal={() => this.setState({confirmClearTokenModalOpen: true})}
              />
          }
          <AlertModal
            alertMessage={<div> Are you <em>sure</em> you want to clear this authorization token? This sponsor will no longer be able to send third party invites from their end.</div> }
            alertTitle="Clear authorization token"
            closeAction={() => this.setState({confirmClearTokenModalOpen: false})}
            confirmAction={this._clearToken}
            confirmText="Yes, clear token"
            declineText="Never mind"
            isOpen={this.state.confirmClearTokenModalOpen}
            type="warning"
          />
        </section>
      </div>
    )
  }
}

AdminUpdateSponsor.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedSponsor: store.sponsor.selected
    , sponsorMap: store.sponsor.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminUpdateSponsor)
);



// WEBPACK FOOTER //
// modules/sponsor/views/AdminUpdateSponsor.js.jsx